import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';
import type { FC } from 'react';

export const NewPasswordRequirementDescription: FC = () => {
  return (
    <div className='flex flex-col gap-xs'>
      <div className='flex flex-col gap-3xs'>
        <div className='text-xs text-plain'>
          Password must contain characters from at least 3 of these categories:
        </div>
        <div className='text-xs text-plain'>
          <ul>
            <li className='flex items-center gap-1'>• Capital Letters (A-Z)</li>

            <li className='flex items-center gap-1'>
              • Lowercase Letters (a-z)
            </li>

            <li className='flex items-center gap-1'>• Numerals (0-9)</li>
            <li className='flex items-center gap-1'>
              • Special characters
              <TooltipIcon
                size='xs'
                icon={'fa-circle-info'}
                content={'Special characters include: !"#$%&\'()*+,-./:;<=>[|]'}
                interactive
              />
            </li>
            <li className='flex items-center gap-1'>
              • Non-ASCII Alphabetic Characters
              <TooltipIcon
                size='xs'
                icon={'fa-circle-info'}
                content={
                  "Non-ASCII Alphabetic Characters include any Unicode character categorized as alphabetic that isn't included above; this includes printable Unicode characters from Asian languages."
                }
                interactive
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
